import * as JobBoardSearchInterfaceModalTemplate from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/addCandidatesFromJobBoards/jobBoardsSupportedParameters/job-boards-search-interface-modal.html';
import * as JobBoardSearchHistoryModalTemplate from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/addCandidatesFromJobBoards/jobBoardsSupportedParameters/job-boards-search-history-modal.html';
class JobBoardsSupportedParametersController {
    /*@ngInject*/
    constructor($uibModal, $sce, $timeout, jobService, modalService) {
        this.$uibModal = $uibModal;
        this.$sce = $sce;
        this.$timeout = $timeout;
        this.jobService = jobService;
        this.modalService = modalService;
    }
    $onInit() {
        //variables
        this.isJobBoardSelected = false;
        this.isGetCandidateFetchCalled = false;
        this.savingFlag = false;
    }
    onJobBoardSelectionChange() {
        this.jobBoardsSelectionChange();
    }
    clearJobBoardsSearchFilters() {
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
            message: "Are you sure you want clear the advanced filters?",
            className: "zIndex1060",
            backdrop: true,
            onEscape: false,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-info'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: (result) => {
                if (result) {
                    this.jobService.removeDaxtraParameters(this.job.id, (data) => {
                        this.job.daxtraParameters = null;
                        bootbox.alert({
                            closeButton: false,
                            title: "<div class='alert alert-success' style='margin-bottom: 0px;'><i class='fa fa-check fa-fw fa-lg'></i><strong>Success!</strong></div>",
                            message: "Job Boards Filters Cleared Successfully",
                            className: "zIndex1060",
                            buttons: {
                                ok: {
                                    label: 'Ok',
                                    className: 'btn-info'
                                }
                            },
                            callback: () => {
                                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                            }
                        });
                    }, (error) => {
                        bootbox.alert({
                            closeButton: false,
                            title: "<div class='alert alert-danger' style='margin-bottom: 0px;'><i class='fa fa-alert fa-fw fa-lg'></i><strong>Error!</strong></div>",
                            message: "Job Boards Filters Clear Failed",
                            className: "zIndex1060",
                            buttons: {
                                ok: {
                                    label: 'Ok',
                                    className: 'btn-info'
                                }
                            },
                            callback: () => {
                                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                            }
                        });
                    });
                }
                else {
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            }
        });
    }
    getJobBoardSearchInterface() {
        let jobBoardCodes = '';
        angular.forEach(this.job.jobBoardDetails, (val, key) => {
            if (val.enabled) {
                jobBoardCodes = jobBoardCodes == '' ? val.daxtraCode : jobBoardCodes + ',' + val.daxtraCode;
            }
        });
        if (jobBoardCodes == '') {
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>No Job Boards Selected!</strong></div>",
                message: "Please select at least one job board to perform this action.",
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: () => {
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }
        else {
            let ctrl = this;
            this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowClass: 'four-dot-five-modal-medium',
                template: JobBoardSearchInterfaceModalTemplate.default,
                controller: ['$uibModalInstance', '$sce', '$timeout', 'jobId', 'jobBoardCodes', 'jobService', 'modalService', 'alertsAndNotificationsService', function ($uibModalInstance, $sce, $timeout, jobId, jobBoardCodes, jobService, modalService, alertsAndNotificationsService) {
                        let vm = this;
                        vm.loadingSearchInterfaceFlag = true;
                        vm.savingFlag = false;
                        vm.jobId = jobId;
                        vm.location = location;
                        vm.searchHtml = '';
                        let searchObject = {};
                        searchObject.dbCode = 'jw_fourdotfive';
                        searchObject.jobBoardCodes = jobBoardCodes;
                        searchObject.jsLib = 'jquery';
                        searchObject.libs = 'css,jb_params_jq,jquery-ui';
                        searchObject.ajaxAutoCompleter = 'http://jbws-az-4dot5.daxtra.com/rtb/spider_params_completer.pl';
                        searchObject.ajaxUpdater = 'http://jbws-az-4dot5.daxtra.com/rtb/spider_params_ajax.pl';
                        searchObject.jsonp = true;
                        searchObject.relayParam = 'daxtra.com';
                        jobService.getJobBoardSearchInterface(searchObject, (data) => {
                            vm.searchHtml = $sce.trustAsHtml(data.t.htmlContent);
                            // data.t.jsContent = data.t.jsContent.replace("<select", "<select class='color-red'");
                            let searchJobParamsJS = "<script>" + data.t.jbParamsJq + "</script>";
                            let searchJS = "<script>" + data.t.jsContent + "</script>";
                            let searchCSS = "<style>" + data.t.cssContent + "</style>";
                            $('#dynamicContentForJobBoardSearch').append(searchCSS);
                            $('#dynamicContentForJobBoardSearch').append(searchJobParamsJS);
                            $('#dynamicContentForJobBoardSearch').append(searchJS);
                            vm.loadingSearchInterfaceFlag = false;
                            $timeout(() => {
                                // remove the 'max results' labels and selection boxes.
                                // remove labels
                                $("label:contains('Max results')").remove();
                                // remove select controls
                                $("select[name$='_max_results']").remove();
                            }, 500);
                        }, (error) => {
                            vm.loadingSearchInterfaceFlag = false;
                            alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        });
                        vm.closeModal = () => {
                            $uibModalInstance.close('cancel');
                        };
                        vm.saveCallback = (locationObject) => {
                            vm.closeModal();
                            updateLocationCallback(locationObject);
                        };
                        vm.loadDaxtraParametersAndImage = (params, image) => {
                            ctrl.loadDaxtraParametersAndImage(params, image);
                        };
                        vm.saveAdvancedSearchParams = () => {
                            vm.savingFlag = true;
                            let advancedSearchArray = $("#jobBoardSearchForm").serializeArray();
                            let advancedSearchObject = {};
                            angular.forEach(advancedSearchArray, (val, key) => {
                                advancedSearchObject[val['name']] = val['value'];
                            });
                            $("#daxtra-ui").scrollTop("0px");
                            $timeout(() => {
                                let getCanvas;
                                html2canvas(document.querySelector("#jb_params")).then((canvas) => {
                                    getCanvas = canvas;
                                    let imageData = getCanvas.toDataURL("image/png");
                                    advancedSearchObject.image = imageData.replace(/^data:image\/png/, "data:application/octet-stream");
                                    jobService.saveDaxtraParameters(this.jobId, advancedSearchObject, (data) => {
                                        vm.savingFlag = false;
                                        bootbox.alert({
                                            closeButton: false,
                                            title: "<div class='alert alert-success' style='margin-bottom: 0px;'><i class='fa fa-check fa-fw fa-lg'></i><strong>Success!</strong></div>",
                                            message: "<span>Advanced Search Parameters saved successfully.</span></br> <span>Hit 'Next' to initiate search and pull candidates.</span>",
                                            className: "zIndex1060",
                                            buttons: {
                                                ok: {
                                                    label: 'Ok',
                                                    className: 'btn-info'
                                                }
                                            },
                                            callback: () => {
                                                vm.closeModal();
                                                ctrl.loadDaxtraParametersAndImage(data.daxtraParameters, data.advancedParametersImage);
                                            }
                                        });
                                    }, (error) => {
                                        vm.savingFlag = false;
                                        alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                    });
                                });
                            }, 2000);
                        };
                    }],
                controllerAs: 'searchModal',
                size: 'lg',
                resolve: {
                    jobId: () => {
                        return ctrl.job.id;
                    },
                    jobBoardCodes: () => {
                        return jobBoardCodes;
                    }
                }
            });
        }
    }
    loadDaxtraParametersAndImage(params, image) {
        this.job.daxtraParameters = params;
        this.job.advancedParametersImage = this.$sce.trustAsResourceUrl(image);
    }
    launchJobBoardSearchHistory() {
        let clientOrBuName = '';
        if (!_.isNull(this.job.clientorbu)) {
            clientOrBuName = this.job.clientorbu.name;
        }
        let ctrl = this;
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            template: JobBoardSearchHistoryModalTemplate.default,
            windowClass: 'four-dot-five-modal-medium',
            controller: ['$uibModalInstance', 'jobId', 'clientOrBuName', 'jobTitle', function ($uibModalInstance, jobId, clientOrBuName, jobTitle) {
                    let vm = this;
                    this.jobId = jobId;
                    this.clientOrBuName = clientOrBuName;
                    this.jobTitle = jobTitle;
                    this.closeModal = () => {
                        $uibModalInstance.close('cancel');
                    };
                    this.saveCallback = () => {
                        this.closeModal();
                    };
                }],
            controllerAs: 'searchHistoryModal',
            resolve: {
                jobId: () => {
                    return ctrl.job.id;
                },
                clientOrBuName: () => {
                    return clientOrBuName;
                },
                jobTitle: () => {
                    return ctrl.job.title;
                }
            }
        });
    }
}
JobBoardsSupportedParametersController.$inject = ['$uibModal', '$sce', '$timeout', 'jobService', 'modalService'];
// import * as TEMPLATE from './job-boards-supported-parameters.html';
import * as TEMPLATE from 'raw-loader!./job-boards-supported-parameters.html';
export const JobBoardsSupportedParametersComponent = {
    selector: 'jobBoardsSupportedParameters',
    component: {
        bindings: {
            job: '=',
            isEditable: '=',
            readOnlyJobBoardsData: '=',
            resumePullOptions: '=',
            radiusOptions: '=',
            recencyOptions: '=',
            resumePullOptions: '=',
            savedResumePullCount: '=',
            activeFilterTab: '=',
            saveCallback: '&',
            jobBoardsSelectionChange: '&',
            context: '@'
        },
        controller: JobBoardsSupportedParametersController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/addCandidatesFromJobBoards/jobBoardsSupportedParameters/job-boards-supported-parameters.html'
    }
};
//# sourceMappingURL=job-boards-supported-parameters.component.js.map